<template>
  <div class="popup">
    <h1 class="page-title text-center mb-5 mb-sm-8">Передача доступа</h1>
    <div class="text-center mb-5 mb-sm-7 sms-confirmation-text">
      После сохранения будет выполнен выход из Вашей ученой записи. 
      После активации нового пользователя Ваша учетная запись будет заблокирована
    </div>
    <div class="text-center">
      <v-btn class="admin-form-base__button button mr-sm-5" color="green" @click="onOk">Применить</v-btn>
      <v-btn class="admin-form-base__button button mt-sm-0 mt-5" color="green" @click="onClose">Отменить</v-btn>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue';
  import BackButton from '@/components/BackButton.vue';


  export default Vue.extend({
    name: 'AccessPassPopup',
    components: {
      BackButton,
    },
    data() {
      return {};
    },
    methods: {
      onOk() {
        this.$emit('onOk');
      },
      onClose() {
        this.$emit('onClose');
      },
    },

  });
</script>

<style scoped lang="scss" src="@/styles/service/base/admin-form.scss"></style>
<style scoped lang="scss" src="@/styles/service/popup.scss"></style>
